import { Clock, LayoutGrid } from "lucide-react";
import { RestaurantBrand } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useLang } from "@/context/LanguageContext";
import { useUI } from "@/context/UIContext";
import { useSession } from "@/context/SessionContext";
import { restaurant } from "@/data/restaurant";

export function TopBar() {
  const { t } = useLang();
  const { table } = useSession();
  const { openServices } = useUI();

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/85 glass pt-safe" data-testid="top-bar">
      <div className="flex items-center justify-between gap-2 px-4 py-3">
        <RestaurantBrand name={restaurant.name} branch={restaurant.branch.name} logoImage={restaurant.logoImage} />
        <div className="flex shrink-0 items-center gap-2">
          <button
            onClick={openServices}
            className="grid h-10 w-10 place-items-center rounded-full border border-border bg-card shadow-soft transition-colors hover:border-primary/40 active:scale-95"
            aria-label={t("services")}
            data-testid="services-btn"
          >
            <LayoutGrid className="h-5 w-5 text-primary" />
          </button>
          <LanguageSelector />
          <ThemeToggle />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1.5 px-4 pb-3">
        {table?.tableNumber != null && (
          <span className="rounded-full brand-gradient px-3 py-1 text-xs font-bold text-white shadow-soft" data-testid="table-badge">
            {t("table")} {table.tableNumber}
          </span>
        )}
        {restaurant.isOpen != null && (
          <span className="flex items-center gap-1.5 rounded-full border border-border bg-card px-3 py-1 text-xs font-semibold">
            <span className={`h-2 w-2 rounded-full ${restaurant.isOpen ? "bg-success" : "bg-destructive"}`} />
            {restaurant.isOpen ? t("open") : t("closed")}
          </span>
        )}
        {restaurant.avgPrepTimeMin != null && (
          <span className="ms-auto flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <Clock className="h-3.5 w-3.5" />
            {t("estPrep")} ~{restaurant.avgPrepTimeMin} {t("min")}
          </span>
        )}
      </div>
    </header>
  );
}
